import WebFont from 'webfontloader'

WebFont.load({
  google: {
    families: ['Lato:400', 'Lato:700', 'Lato:900'],
  },
  fontinactive(familyName, fvd) {
    window.console.warn('WebFont.load() failed to load font:', {
      familyName,
      fvd,
    })
  },
})



// WEBPACK FOOTER //
// ../source/assets/fonts.js